import React from 'react';

import { FormInstance } from 'antd';
import {
  Switch,
  Input,
} from 'UI';

import {
  FormContainer,
  BaseFormItem,
} from './style';

export interface AddUserFormData {
  name: string
  email: string
  password: string,
  isAdmin: boolean
  isActive: boolean
}

interface AddFormProps {
  formHandler: FormInstance
  onSubmit(data: unknown): void
  isLoading?: boolean
}

const AddForm = ({
  formHandler,
  onSubmit,
  isLoading,
}: AddFormProps): JSX.Element => (
  <FormContainer
    layout="vertical"
    form={formHandler}
    requiredMark={false}
    onFinish={onSubmit as (val: unknown) => void}
  >
    <BaseFormItem
      label="Nome"
      name="name"
      rules={[
        {
          required: true,
          message: 'Insira um nome',
        },
      ]}
    >
      <Input disabled={isLoading} />
    </BaseFormItem>
    <BaseFormItem
      label="E-mail"
      name="email"
      rules={[
        {
          required: true,
          message: 'Insira um e-mail',
        },
      ]}
    >
      <Input disabled={isLoading} />
    </BaseFormItem>
    <BaseFormItem
      label="Senha"
      name="password"
      rules={[
        {
          required: true,
          message: 'Insira uma senha',
        },
        {
          min: 8,
          message: 'A senha deve ter pelo menos 8 caracteres',
        },
      ]}
    >
      <Input type="password" disabled={isLoading} />
    </BaseFormItem>
    <BaseFormItem
      label="Administrador"
      name="isAdmin"
      valuePropName="checked"
      initialValue={false}
    >
      <Switch disabled={isLoading} />
    </BaseFormItem>
    <BaseFormItem
      label="Ativo"
      name="isActive"
      valuePropName="checked"
      initialValue
    >
      <Switch disabled={isLoading} />
    </BaseFormItem>
  </FormContainer>
);

AddForm.defaultProps = {
  isLoading: false,
};

export default AddForm;
